/* 🧠 REDUX */
import { store } from "../../Redux/Store";
import { changeModal, changePopup } from "../../Redux/Actions";

/* 🔧 UTILS */
import { createStep } from "./index";

const isMobile = window.matchMedia("(max-width: 1080px)").matches;
const isLandscape = window.matchMedia("(orientation: landscape)").matches;

export const dashboardSteps = (t) => [
    createStep({
      selector: '#reports-button',
      stepNumber: 1,
      titleKey: t("tour.dashboard.reports-button.title"),
      textKey: t("tour.dashboard.reports-button.text"),
    }),
    createStep({
      selector: '#reports-modal',
      stepNumber: 2,
      titleKey: t("tour.dashboard.reports-modal.title"),
      textKey: t("tour.dashboard.reports-modal.text"),
    }),
    createStep({
      selector: '#download-restrictions',
      stepNumber: 3,
      titleKey: t("tour.dashboard.download-restrictions.title"),
      textKey: t("tour.dashboard.download-restrictions.text"),
    }),
    createStep({
      selector: '#calendar-popup-button',
      stepNumber: 4,
      titleKey: t("tour.dashboard.calendar-popup-button.title"),
      textKey: t("tour.dashboard.calendar-popup-button.text"),
    }),
    createStep({
      selector: '#calendar-popup',
      stepNumber: 5,
      titleKey: t("tour.dashboard.calendar-popup.title"),
      textKey: t("tour.dashboard.calendar-popup.text"),
    }),
    createStep({
      selector: isMobile ? '#fav-card-mobile' : '#fav-card',
      stepNumber: 6,
      titleKey: t("tour.dashboard.fav-card.title"),
      textKey: t("tour.dashboard.fav-card.text"),
    }),
    createStep({
      selector: isLandscape && isMobile ? '#bardays-landscape' : '#bardays',
      stepNumber: 7,
      titleKey: t("tour.dashboard.bardays.title"),
      textKey: t("tour.dashboard.bardays.text"),
    }),
    createStep({
      selector: isLandscape && isMobile ? '#bardays-landscape-buttons' : '#bardays-buttons',
      stepNumber: 8,
      titleKey: t("tour.dashboard.bardays-buttons.title"),
      textKey: t("tour.dashboard.bardays-buttons.text"),
    }),
    createStep({
      selector: isLandscape && isMobile ? '#datepicker-landscape-button' : '#datepicker-button',
      stepNumber: 9,
      titleKey: t("tour.dashboard.datepicker-button.title"),
      textKey: t("tour.dashboard.datepicker-button.text"),
      position: "top",
    }),
    createStep({
      selector: isLandscape && isMobile ? '#today-button-landscape' : '#today-button',
      stepNumber: 10,
      titleKey: t("tour.dashboard.today-button.title"),
      textKey: t("tour.dashboard.today-button.text"),
    }),
    createStep({
      selector: isMobile ? "#unpin-icon-mobile" : "#unpin-icon",
      stepNumber: 11,
      titleKey: t("tour.dashboard.unpin-icon.title"),
      textKey: t("tour.dashboard.unpin-icon.text"),
    }),
    createStep({
      selector: isMobile ? "#swiper-mobile" : "#swiper",
      stepNumber: 12,
      titleKey: t("tour.dashboard.swiper.title"),
      textKey: t("tour.dashboard.swiper.text"),
    }),
    createStep({
      selector: isMobile ? "#search-card-mobile" : "#search-card",
      stepNumber: 13,
      titleKey: t("tour.dashboard.search-card.title"),
      textKey: t("tour.dashboard.search-card.text"),
    }),
    createStep({
      selector: '#change-fav-cards',
      stepNumber: 14,
      titleKey: t("tour.dashboard.change-fav-cards.title"),
      textKey: t("tour.dashboard.change-fav-cards.text"),
    }),
    createStep({
      selector: '#empty-space',
      stepNumber: 15,
      titleKey: t("tour.dashboard.empty-space.title"),
      textKey: t("tour.dashboard.empty-space.text"),
    }),
]

export const handleDashboardPrevStep = (currentStep, setCurrentStep) => {
    const stepActions = {
        1: () => {
            store.dispatch(changeModal(''));
            setCurrentStep(0);
        },
        3: () => {
            store.dispatch(changeModal('reports'));
            setCurrentStep(2);
        },
        4: () => {
            store.dispatch(changePopup(''));
            setCurrentStep(3);
        },
        5: () => {
            store.dispatch(changePopup('calendar'));
            setCurrentStep(4);
        }
    };
  
    if (stepActions[currentStep]) {
        stepActions[currentStep]();
    } else {
        setCurrentStep(currentStep - 1);
    }
};

export const handleDashboardNextStep = (currentStep, setCurrentStep, setIsOpen) => {
  
    const stepActions = {
      0: () => {
        store.dispatch(changeModal('reports'));
        setCurrentStep(1);
      },
      2: () => {
        store.dispatch(changeModal(''));
        setCurrentStep(3);
      },
      3: () => {
        store.dispatch(changePopup('calendar'));
        setCurrentStep(4);
      },
      4: () => {
        store.dispatch(changePopup(''));
        setCurrentStep(5);
      },
      13: () => {
        const unpinButton = document.querySelector("#unpin-card1");
        unpinButton && unpinButton.click();
        setCurrentStep(14);
      },
      14: () => {
        setIsOpen(false);
        setCurrentStep(0);
      }
    };

    if (stepActions[currentStep]) {
      stepActions[currentStep]();
    } else {
      setCurrentStep(currentStep + 1);
    }
};

